export { default } from './OOSProductImage';
